export default __webpack_public_path__ + "static/media/watches11.f7f5fa82.jfif";